// extracted by mini-css-extract-plugin
export default {"root":"kpgKaD4gXZTUY5bPgDwF","skip":"uqzFahh2khc2tPwNxZlT"};